import styled from 'styled-components'

import { Grid } from 'mf-ui-components'

export const Container = styled(Grid).attrs({
  flow: 'row',
})`
  position: relative;
  mask-image: linear-gradient(
    to right,
    transparent 0%,
    white 2%,
    white 98%,
    transparent 100%
  );
`
